import { FC } from 'react';
import { css } from '@emotion/react';
import { useIsSmallMode } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { trackingIds } from '../../../../../tracking-ids';

interface ActionProps {
  label: string;
  onClick: () => void;
  trackingId?: string;
  disabled?: boolean;
}

interface FilterTrayActionProps {
  clearAllAction?: ActionProps;
  primaryAction?: ActionProps;
  dismissAction?: ActionProps;
}

export const FilterTrayAction: FC<FilterTrayActionProps> = ({ clearAllAction, primaryAction, dismissAction }) => {
  const { isSmallMode } = useIsSmallMode();
  return (
    <div css={styles.container}>
      {clearAllAction && (
        <Button
          variant={isSmallMode ? 'tertiary' : 'secondary'}
          trackingId={clearAllAction.trackingId || trackingIds.callIntel.filterTrayClearAllAction}
          onClick={clearAllAction.onClick}
          disabled={clearAllAction.disabled}
          css={{ marginRight: isSmallMode ? 'auto' : 'unset' }}
        >
          {clearAllAction.label}
        </Button>
      )}
      {isSmallMode && dismissAction && (
        <Button
          variant='secondary'
          trackingId={dismissAction.trackingId}
          onClick={dismissAction.onClick}
          disabled={dismissAction.disabled}
        >
          {dismissAction.label}
        </Button>
      )}
      {primaryAction && (
        <Button
          variant='primary'
          trackingId={primaryAction.trackingId}
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled}
        >
          {primaryAction.label}
        </Button>
      )}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    gap: ${theme.spacing(2)};
    align-items: center;
    justify-content: flex-end;
    padding: ${theme.spacing(2, 4)};
    border-top: 1px solid ${theme.colors.neutral10};
  `,
};
